import { render, staticRenderFns } from "./SignInHeading.vue?vue&type=template&id=3e23a91a&scoped=true&"
import script from "./SignInHeading.vue?vue&type=script&lang=js&"
export * from "./SignInHeading.vue?vue&type=script&lang=js&"
import style0 from "./SignInHeading.vue?vue&type=style&index=0&id=3e23a91a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e23a91a",
  null
  
)

export default component.exports